import React from "react";
import PropTypes from "prop-types";

import Loader from "./SpreedlyLoader";
import DisplayError from "./SpreedlyDisplayError";
import classNames from "classnames";

const Errors = (error) => {
  return <div>{error}</div>;
};
export class SpreedlyForm extends React.Component {
  state = {
    loading: true,
    showCVVHelp: false,
  };

  constructor() {
    super();
  }

  mounted = false;

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextState.loading !== this.state.loading ||
      nextProps.first_name !== this.props.first_name ||
      nextProps.last_name !== this.props.last_name ||
      nextProps.email !== this.props.email ||
      nextProps.address !== this.props.address ||
      nextProps.city !== this.props.city ||
      nextProps.region !== this.props.region ||
      nextProps.zip !== this.props.zip ||
      nextProps.country !== this.props.country ||
      nextProps.phone !== this.props.phone ||
      nextProps.validationErrors.get("cvv") !== this.props.validationErrors.get("cvv") ||
      nextProps.validationErrors.get("cardNumber") !==
        this.props.validationErrors.get("cardNumber") ||
      nextState.showCVVHelp !== this.state.showCVVHelp
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.runValidation) {
      this.handleValidation();
    }
  }

  generateStyling() {
    const { isEmbedded } = this.props;
    if (!isEmbedded) {
      this.spreedly.setLabel("number", "Card Number");
      this.spreedly.setLabel("cvv", "CVV");

      const inputStyles =
        "width: 100%;  height: 2.5em; border-radius: 2px; " +
        'border: 1px solid #e2e2e2; font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;' +
        "padding-left: 5%; font-size: 14px; color: #333; box-sizing: border-box;";

      this.spreedly.setStyle("number", inputStyles);
      this.spreedly.setStyle("cvv", inputStyles);
    }

    this.spreedly.setFieldType("number", "text");
    this.spreedly.setNumberFormat("prettyFormat");
  }

  componentDidMount() {
    const {
      spreedlyKey,
      setSpreedlyToken,
      setSpreedlyErrors,
      afterSpreedlyValidation,
      isEmbedded,
    } = this.props;

    this.mounted = true;

    this.spreedly = new SpreedlyPaymentFrame();
    this.spreedly.init(spreedlyKey, {
      numberEl: "spreedly-number",
      cvvEl: "spreedly-cvv",
    });
    this.spreedly.on("ready", () => {
      // check needed since ready will fire when component is unmounted or mounted
      if (this.mounted) {
        this.setState((prev) => {
          return {
            loading: false,
          };
        });
      }

      if (isEmbedded) {
        this.styleEmbeddedInputs();
      }

      this.generateStyling();

      this.spreedly.on("errors", (errors) => {
        const formatted = errors.reduce((prev, err) => {
          prev[err.attribute] = err.message;

          return prev;
        }, {});

        setSpreedlyErrors(formatted);
        this.handleFailedValidation();
      });

      this.spreedly.on("validation", (inputProperties) => {
        const { validCvv, validNumber } = inputProperties;

        if (validCvv && validNumber) {
          setSpreedlyErrors();
          this.handleSubmit();
        } else {
          setSpreedlyErrors({ cvv: !validCvv, cardNumber: !validNumber });
          this.handleFailedValidation();
        }
      });

      this.spreedly.on("paymentMethod", (token) => {
        setSpreedlyToken(token);
        afterSpreedlyValidation();
      });
    });
  }

  componentWillUnmount() {
    this.spreedly.removeHandlers();
    this.mounted = false;
  }

  handleValidation() {
    const { triggerSpreedlyValidation } = this.props;

    triggerSpreedlyValidation(false);
    this.spreedly.validate();
  }

  handleFailedValidation() {
    const { afterFailedSpreedlyValidation } = this.props;

    afterFailedSpreedlyValidation();
  }

  handleSubmit() {
    const {
      first_name,
      last_name,
      year,
      month,
      address,
      city,
      region,
      zip,
      country,
      phone,
      spreedlyKey,
    } = this.props;

    this.spreedly.tokenizeCreditCard({
      environment_key: spreedlyKey,
      first_name,
      last_name,
      month,
      year: `20${year}`,
      address1: address,
      city,
      state: region,
      zip,
      country,
      phone_number: phone,
    });
  }

  styleEmbeddedInputs() {
    this.spreedly.setPlaceholder("number", "*Card Number");
    this.spreedly.setPlaceholder("cvv", "*CVV");
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      this.spreedly.setStyle("number", "width:95.57%;");
      this.spreedly.setStyle("cvv", "width:85%;");
    } else {
      this.spreedly.setStyle("number", "width:336px;");
      this.spreedly.setStyle("cvv", "width:88px;");
    }

    this.spreedly.setStyle(
      "number",
      "height:37px; border-radius: 30px; border: solid 1px #cccccc; padding-left: 10px;",
    );
    this.spreedly.setStyle(
      "cvv",
      "height:35px; border-radius: 30px; border: solid 1px #cccccc; padding-left: 10px;",
    );
  }

  render() {
    const { validationErrors, isEmbedded } = this.props;
    const { loading } = this.state;
    const hideInputs = loading ? "hidden" : "";

    if (isEmbedded) {
      return (
        <React.Fragment>
          <div className="col-xs-12 col-sm-7 height-spreedly-input">
            <Loader loading={loading} />
            <div
              id="spreedly-number"
              className={loading ? "hidden" : ""}
              style={{ width: "350px" }}
            />
            <DisplayError
              error={validationErrors.get("cardNumber")}
              classRootName="spreedly-card-number"
              type="card number"
            />
          </div>
          <div className="col-xs-12 col-sm-2 height-spreedly-input">
            <Loader loading={loading} />
            <div
              id="spreedly-cvv"
              className={classNames(`card-cvv ${hideInputs}`)}
              style={{}}
            />
            <DisplayError
              error={validationErrors.get("cvv")}
              classRootName="spreedly-cvv"
              type="CVV"
            />
            {this.state.showCVVHelp ? this.renderCVVHelp() : ""}
          </div>
        </React.Fragment>
      );
    }

    return (
      <div className="row">
        <div className="col-xs-12 col-md-6 p-sm-b">
          <label className="required-field">card number</label>
          <Loader loading={loading} />
          <div
            id="spreedly-number"
            className={loading ? "hidden" : ""}
            style={{ height: "2.5em" }}
          />
          <DisplayError
            classRootName="p-sm-t p-sm-l"
            error={validationErrors.get("cardNumber")}
            type="card number"
          />
        </div>
        <div className="col-xs-12 col-md-6 p-sm-b">
          <label className="required-field">
            cvv
            <a
              data-testid="t-shared-compone--Spreedl-a"
              onClick={() => this.toggleShowCVVHelp()}
              target="_blank">
              <span
                className="fa fa-fw fa-info-circle"
                style={{ cursor: "pointer" }}></span>
            </a>
          </label>
          <Loader loading={loading} />
          <div
            id="spreedly-cvv"
            className={loading ? "hidden" : ""}
            style={{ height: "2.5em" }}
          />
          <DisplayError
            classRootName="p-sm-t p-sm-l"
            error={validationErrors.get("cvv")}
            type="CVV"
          />
          {this.state.showCVVHelp ? this.renderCVVHelp() : ""}
        </div>
      </div>
    );
  }
  toggleShowCVVHelp() {
    this.setState({ showCVVHelp: !this.state.showCVVHelp });
  }
  renderCVVHelp() {
    return (
      <div>
        Security Code: 3 digits to the right of the signature on back of card, or 4 digits
        on front for AMEX.
      </div>
    );
  }
}

SpreedlyForm.propTypes = {
  spreedlyKey: PropTypes.string.isRequired,
  triggerSpreedlyValidation: PropTypes.func.isRequired,
  afterSpreedlyValidation: PropTypes.func.isRequired,
  token: PropTypes.string,

  // props needed for spreedly tokenization
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  month: PropTypes.string,
  year: PropTypes.string,
  isEmbedded: PropTypes.bool,
};

export default SpreedlyForm;
